/** `categories.main` values — aligned with backend CategorySchema enum. */
export const INFLUENCER_CATEGORY_MAIN = [
    'Fashion',
    'Beauty & Skincare',
    'Fitness & Health',
    'Lifestyle',
    'Travel & Adventure',
    'Food & Cooking',
    'Technology & Gadgets',
    'Gaming',
    'Parenting & Family',
    'Education & Career',
    'Art & Design',
    'Music & Performance',
    'Finance & Investing',
    'Comedy & Entertainment',
    'Automotive',
    'Book Recommendations',
    'Sustainable Living',
    'Pet Influencers',
    'Spirituality & Mindfulness',
    'Minimalism',
    'DIY Home Renovation',
] as const;

export type InfluencerCategoryMain = (typeof INFLUENCER_CATEGORY_MAIN)[number];
